import { getApprovals } from "@/services/approvals.service";
import { useQuery } from "@tanstack/react-query";

export const useApprovals = (
  enabled = true,
  params = { page: 0, size: 10 },
  options = {},
) => {
  const queryKey = [
    "approvals",
    params.page,
    params.size,
    params.sort,
    params.search,
    params.status,
  ];

  return useQuery({
    queryKey,
    queryFn: () => getApprovals(params),
    enabled,
    ...options,
  });
};
